
export enum PricingAnalysisRunTypeCd {
	ADHOC = 'Adhoc',
	RFP = 'RFP'}

